module.exports = __webpack_public_path__ + "img/snake.2b313000.png";